<template>
    <div>

         <!-- ======= CAROUSEL ======= -->
     <div class="text-center">
      <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" style="height: auto !important;">
         <div class="carousel-indicators">
            <button v-for="(data, idx) in list_slider"
               :key="data.id" type="button"
               data-bs-target="#carouselExampleIndicators"
               :data-bs-slide-to="idx"
               :class="cek_active(idx)">
            </button>
         </div>
         <div class="carousel-inner">
            <div v-for="(data, idx) in list_slider" :key="data.id" :class="'carousel-item '+cek_active(idx)">
                <div class="carousel-item-wrapper">
                    <img class="carousel-image" :src="file_path + data.file" alt="First slide" />
                </div>
            </div>
         </div>
         <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
         </button>
         <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
         </button>
      </div>
   </div>
   <!-- ======= CAROUSEL ======= -->
        <!-- main-area -->
        <main class="fix">
            

            <section class="all_services__area-six">
                <div class="container">
                    <h2>
                        DPRD KABUPATEN KONAWE SELATAN
                    </h2>
                    <p v-html="sejarah_isi"></p>
                    <router-link to="/ProfilDewan" class="btn" data-aos="fade-up" data-aos-delay="600">Profil Dewan</router-link>
                    <!-- <a  class="btn" data-aos="fade-up" data-aos-delay="600">Profil Dewan</a> -->
                </div>
            </section>




            <!-- blog-post-area -->
            <section class="blog__post-area-five marketing__area-home12">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6">
                            <div class="section-title text-center mb-50 tg-heading-subheading animation-style3">
                                <!-- <span class="sub-title">Berita Terbaru</span> -->
                                <h5 class="title tg-element-title">Berita Terbaru</h5 >
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-xl-4 col-lg-6 col-md-10"  v-for="data in list_berita" :key="data.id">
                            <div class="blog-post-item blog__post-three shine-animate-item">
                                <div class="blog-post-thumb blog__post-thumb-three">
                                    <a  @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"  class="shine-animate"><img :src="file_path+data.foto" alt="Apexa" /></a>
                                </div>
                                <div class="blog-post-content blog__post-content-three">
                                    <a href="javascript:void(0);" class="post-tag">{{data.kategori_id}}</a>
                                    <h2 class="title">
                                        <a  @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul" ><span>{{ truncateText(data.judul, 80) }}</span></a>
                                        </h2>
                                    <div class="blog-post-meta mb-20">
                                        <ul class="list-wrap">
                                            <li><i class="fas fa-calendar-alt"></i>{{convert_tgl(data.createAt)}}</li>
                                        </ul>
                                    </div>
                                    <!-- <a @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"  class="btn">Baca Selengkapnya</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="blog-shape-wrap">
                    <img src="assets/img/images/h5_blog_shape01.png" alt="Apexa" data-aos="fade-right" data-aos-delay="400" />
                    <img src="assets/img/images/h5_blog_shape02.png" alt="Apexa" data-aos="fade-left" data-aos-delay="400" />
                </div>

                <div class="project-content-bottom">
                <!-- <a href="javascript:void(0);" class="btn">Foto Lainnya</a> -->
                <router-link to="/BeritaOPD" class="btn">Berita Lainnya</router-link>
            </div>
            </section>
            <!-- blog-post-area-end -->


            <section class="about__area-two about__bg" data-background="assets/img/bg/about_bg.jpg">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6 col-lg-7">
                            <div class="section-title text-center mb-50 tg-heading-subheading animation-style3">
                                <span class="sub-title">Gallery</span>
                                <h2 class="title tg-element-title">Foto Terbaru</h2>
                            </div>
                        </div>
                    </div>
                    <div class="row gutter-24">
                        <div class="col-lg-4 col-md-6" v-for="data in list_foto.slice(0, 6)" :key="data.id">
                            <div class="project__item-two">
                                <div class="project__thumb-two">
                                    <img :src="file_path+data.file" alt="">
                                </div>
                                <div class="project__content-two">
                                    <h2 class="title"><a @click.prevent="showModal(data)">{{data.judul}}</a></h2>
                                    <span>{{convert_tgl(data.createAt)}}</span>
                                    <div class="link-arrow link-arrow-two">
                                        <a @click.prevent="showModal(data)">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6293 3.27956C17.7117 2.80339 17.4427 2.34761 17.0096 2.17811C16.9477 2.15384 16.8824 2.13551 16.8144 2.12375L6.96087 0.419136C6.4166 0.325033 5.89918 0.689841 5.80497 1.23409C5.71085 1.77828 6.0757 2.29576 6.61988 2.38991L14.0947 3.68293L1.3658 12.6573C0.914426 12.9756 0.806485 13.5994 1.12473 14.0508C1.44298 14.5022 2.06688 14.6101 2.51825 14.2919L15.2471 5.31752L13.954 12.7923C13.8599 13.3365 14.2248 13.854 14.7689 13.9481C15.3132 14.0422 15.8306 13.6774 15.9248 13.1332L17.6293 3.27956Z" fill="currentcolor" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6293 3.27956C17.7117 2.80339 17.4427 2.34761 17.0096 2.17811C16.9477 2.15384 16.8824 2.13551 16.8144 2.12375L6.96087 0.419136C6.4166 0.325033 5.89918 0.689841 5.80497 1.23409C5.71085 1.77828 6.0757 2.29576 6.61988 2.38991L14.0947 3.68293L1.3658 12.6573C0.914426 12.9756 0.806485 13.5994 1.12473 14.0508C1.44298 14.5022 2.06688 14.6101 2.51825 14.2919L15.2471 5.31752L13.954 12.7923C13.8599 13.3365 14.2248 13.854 14.7689 13.9481C15.3132 14.0422 15.8306 13.6774 15.9248 13.1332L17.6293 3.27956Z" fill="currentcolor" />
                                            </svg>
                                        </a>
                                    </div>

                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="about__shape-wrap-two">
                <img src="assets/img/images/h2_about_shape01.png" alt="" data-parallax='{"x" : -80 , "y" : 80 , "rotateZ":80}'>
                <img src="assets/img/images/h2_about_shape02.png" alt="" data-parallax='{"y" : 100 }'>
                <img src="assets/img/images/h2_about_shape03.png" alt="" data-aos="fade-left" data-aos-delay="400">
            </div>
            <div class="project-content-bottom">
                <!-- <a href="javascript:void(0);" class="btn">Foto Lainnya</a> -->
                <router-link to="/FotoOPD" class="btn">Foto Lainnya</router-link>
            </div>

                                
            </section>
            <!-- project-area-end -->

           <!-- Jika ≤ 5: Static Centered Display -->
<div v-if="list_link_terkait.length <= 5" class="brand-area">
  <div class="container">
    <div class="d-flex justify-content-center align-items-center flex-wrap" style="gap: 40px;">
      <div v-for="data in list_link_terkait" :key="data.id" class="brand-item" style="width: 160px; text-align: center;">
        <a :href="data.url" target="_blank" rel="noopener noreferrer">
          <img :src="file_path + data.file" alt="" style="height: 80px; width: 100%; object-fit: contain;">
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Jika > 5: Swiper Active -->
<div v-else class="brand-area">
  <div class="container">
    <div class="swiper-container brand-active">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="data in list_link_terkait" :key="data.id">
          <div class="brand-item">
            <a :href="data.url" target="_blank" rel="noopener noreferrer">
              <img :src="file_path + data.file" alt="" style="height: 80px; width: 100%; object-fit: contain;">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




        </main>
    </div>

    <div class="modal fade" id="fotoModal" tabindex="-1" aria-labelledby="fotoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="fotoModalLabel">{{form.judul }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
                </div>
                <div class="modal-body text-center">
                    <img :src="file_path + form.file" alt="Foto Detail" class="img-fluid mb-3" />
                    <p>{{ form.deskripsi }}</p>
                </div>
                </div>
            </div>
        </div>

    <!-- Modal Pop-up Infografis / Banner Ucapan -->
    <div class="modal fade popup-infografis-modal" id="popupInfografisModal" tabindex="-1" aria-labelledby="popupInfografisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content popup-modal-content">
          <button type="button" class="popup-close-btn" data-bs-dismiss="modal" aria-label="Tutup" title="Tutup">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </button>
          
          <div class="modal-body p-0 text-center">
            <!-- Jika lebih dari 1 infografis: gunakan Swiper Slide -->
            <div v-if="list_infografis.length > 1" class="swiper-container infografis-swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="info in list_infografis" :key="info.id">
                  <div class="popup-image-wrap">
                    <img :src="file_path + info.file" :alt="info.judul" class="popup-img" />
                    <div v-if="info.judul" class="popup-caption">
                      <div class="popup-title">{{ info.judul }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-button-next popup-nav-btn"></div>
              <div class="swiper-button-prev popup-nav-btn"></div>
              <div class="swiper-pagination popup-pagination"></div>
            </div>

            <!-- Jika hanya 1 infografis -->
            <div v-else-if="list_infografis.length === 1" class="popup-image-wrap">
              <img :src="file_path + list_infografis[0].file" :alt="list_infografis[0].judul" class="popup-img" />
              <div v-if="list_infografis[0].judul" class="popup-caption">
                <div class="popup-title">{{ list_infografis[0].judul }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import { useStore } from 'vuex'
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

export default {
  data() {
    const store = useStore()
    const baseURL = store.state.URL_APP

    return {
      unit_kerja: store.state.UNIT_KERJA,
      file_path: baseURL + 'uploads/',
      sejarah_isi: "",
      list_slider: [],
      list_berita: [],
      list_foto: [],
      list_infografis: [],
      list_link_terkait: [],
      form : {
            id : '',
            judul : '',
            deskripsi : '',
            file : '',
            unit_kerja : '',
            status : '',
            createBy : '',
            createAt : '',
        },
    }
  },
  mounted() {
     // Inisialisasi Swiper
        // new window.Swiper('.brand-active', {
        //     slidesPerView: 5,
        //     spaceBetween: 30,
        //     loop: true,
        //     autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: false,
        //     },
        //     breakpoints: {
        //     320: { slidesPerView: 2 },
        //     768: { slidesPerView: 3 },
        //     1024: { slidesPerView: 5 }
        //     }
        // })
        this.$nextTick(() => {
            if (this.list_link_terkait.length > 5) {
                new Swiper('.brand-active', {
                loop: false, // TIDAK perlu loop
                centeredSlides: false,
                slidesPerView: 5,
                spaceBetween: 40,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                breakpoints: {
                    320: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    992: { slidesPerView: 4 },
                    1200: { slidesPerView: 5 }
                }
                });
            }
            });


    this.getSejarah()
    this.getSlider();
    this.getListBerita();
    this.getFoto();
    this.getInfografis();
    this.getLinkTerkait();
  },
  methods: {

    showModal(data) {
                this.form = data;

                // trigger Bootstrap Modal (v5)
                // eslint-disable-next-line no-undef
                const modal = new bootstrap.Modal(document.getElementById('fotoModal'));
                modal.show();
            },

    truncateText(text, limit = 50) {
    if (!text) return '';
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  },

    cek_active(index) {
      return index === 0 ? 'active' : '';
    },
    getSejarah: function() {
        if (!this.$store.state.URL_SEJARAH) return;
        fetch(this.$store.state.URL_SEJARAH + "sejarah", {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
            .then(res => res.json())
            .then(res_data => { 
                if (Array.isArray(res_data) && res_data.length > 0) {
                    var sejarah = res_data[0];
                    this.sejarah_isi = sejarah.uraian; 
                }
            })
            .catch(err => {
                console.error("getSejarah error:", err);
            });
    },

    getLinkTerkait: function () {
        const url_link = this.$store.state.URL_APP + "api/v1/web_publish_link_terkait/";
        fetch(url_link, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token,
            },
            body: JSON.stringify({
                unit_kerja: this.unit_kerja,
            }),
        })
        .then((res) => res.json())
        .then((res_data) => {
            this.list_link_terkait = Array.isArray(res_data) ? res_data : [];
            this.$nextTick(() => {
                new Swiper(".brand-active", {
                    loop: true,
                    spaceBetween: 30,
                    slidesPerView: 4,
                    autoplay: {
                        delay: 3000,
                    },
                    breakpoints: {
                        0: { slidesPerView: 2 },
                        576: { slidesPerView: 3 },
                        768: { slidesPerView: 4 },
                        992: { slidesPerView: 5 },
                    },
                });
            });
        })
        .catch(err => {
            console.error("getLinkTerkait error:", err);
            this.list_link_terkait = [];
        });
    },

    push_berita : function(id){
        this.$router.push('/isi_berita?id='+id);
    },

    getSlider: function() {
        if (!this.$store.state.URL_SLIDER) return;
        fetch(this.$store.state.URL_SLIDER, {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
            .then(res => res.json())
            .then(res_data => { 
                this.list_slider = Array.isArray(res_data) ? res_data : [];
            })
            .catch(err => {
                console.error("getSlider error:", err);
                this.list_slider = [];
            });
    },

    getListBerita: function() {
        if (!this.$store.state.ADD_URL_BERITA) return;
        this.cek_load_data_list = true;
        fetch(this.$store.state.ADD_URL_BERITA + "homeOPDSetwan", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                unit_kerja: this.unit_kerja,
                kategori_id: this.kategori_id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_berita = Array.isArray(res_data) ? res_data : [];
            })
            .catch(err => {
                console.error("getListBerita error:", err);
                this.list_berita = [];
            });
    },

    getFoto: function() {
        fetch(this.$store.state.ADD_FOTO, {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
            .then(res => res.json())
            .then(res_data => { 
                console.log('🔍 list_foto:', res_data);
                if (Array.isArray(res_data) && res_data.length >= 6) {
                    this.list_foto = res_data.slice(0, 6);
                } else {
                    fetch(this.$store.state.ADD_FOTO + "view", {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                        },
                        body: JSON.stringify({
                            data_ke: 1,
                            cari_value: "",
                            kategori: "",
                        }),
                    })
                    .then(r => r.json())
                    .then(viewData => {
                        if (viewData && Array.isArray(viewData.data) && viewData.data.length > 0) {
                            this.list_foto = viewData.data.slice(0, 6);
                        } else {
                            this.list_foto = Array.isArray(res_data) ? res_data.slice(0, 6) : [];
                        }
                    })
                    .catch(() => {
                        this.list_foto = Array.isArray(res_data) ? res_data.slice(0, 6) : [];
                    });
                }
        })
        .catch(() => {
            this.list_foto = [];
        });
    },

    convert_tgl : function(dateString){
                  var date = new Date(dateString);
                  var getBulan = date.getMonth() + 1; var bulan = '';
                  if (getBulan == '1') {bulan = 'Jan'} 
                  else if(getBulan == '2') {bulan = 'Feb'}
                  else if(getBulan == '3') {bulan = 'Mar'}
                  else if(getBulan == '4') {bulan = 'Apr'}
                  else if(getBulan == '5') {bulan = 'Mei'}
                  else if(getBulan == '6') {bulan = 'Jun'}
                  else if(getBulan == '7') {bulan = 'Jul'}
                  else if(getBulan == '8') {bulan = 'Agt'}
                  else if(getBulan == '9') {bulan = 'Sep'}
                  else if(getBulan == '10') {bulan = 'Okt'}
                  else if(getBulan == '11') {bulan = 'Nov'}
                  else if(getBulan == '12') {bulan = 'Des'}



                  return date.getDate() + " " + bulan + " " + date.getFullYear();
              },

    getInfografis: function() {
      if (!this.$store.state.URL_INFOGRAFIS) return;
      fetch(this.$store.state.URL_INFOGRAFIS, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      })
      .then(res => res.json())
      .then(res_data => {
        if (Array.isArray(res_data) && res_data.length > 0) {
          const now = new Date().getTime();
          const THREE_DAYS = 3 * 24 * 60 * 60 * 1000;
          this.list_infografis = res_data.filter(item => {
            if (!item.createAt) return true;
            const itemTime = new Date(item.createAt).getTime();
            return (now - itemTime) <= THREE_DAYS;
          });

          if (this.list_infografis.length > 0) {
            this.$nextTick(() => {
              const modalEl = document.getElementById("popupInfografisModal");
              if (modalEl) {
                // eslint-disable-next-line no-undef
                const modal = new bootstrap.Modal(modalEl);
                modal.show();

                if (this.list_infografis.length > 1) {
                  new Swiper(".infografis-swiper", {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    loop: false,
                    navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },
                  });
                }
              }
            });
          }
        }
      })
      .catch(err => {
        console.error("Error fetching infografis:", err);
      });
    },

  },
}
</script>

<style scoped>
.hero {
  padding: 60px 0;
  background-color: #f8f9fa;
  text-align: center;
}

/* POPUP INFOGRAFIS TRANSPARAN */
.popup-modal-content {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  position: relative;
}

.popup-close-btn {
  position: absolute;
  top: -16px;
  right: -16px;
  z-index: 1055;
  background: rgba(15, 23, 42, 0.85);
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;
  outline: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}
.popup-close-btn:hover {
  background: #dc3545;
  border-color: #ffffff;
  transform: scale(1.1);
}

.popup-image-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 100%;
}

.popup-img {
  max-height: 70vh;
  max-width: 100%;
  width: auto;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.65);
  object-fit: contain;
}

.popup-caption {
  margin-top: 10px;
  background: rgba(15, 23, 42, 0.92) !important;
  backdrop-filter: blur(8px);
  padding: 10px 24px;
  border-radius: 24px;
  max-width: 95%;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
}

.popup-title {
  font-size: 15px !important;
  line-height: 1.4 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  margin: 0 !important;
}

.popup-desc {
  font-size: 13px !important;
  line-height: 1.4 !important;
  margin-top: 4px !important;
  color: #e2e8f0 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.9);
  margin-bottom: 0 !important;
}

.popup-nav-btn {
  color: #ffffff !important;
  background: rgba(15, 23, 42, 0.7);
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s;
}
.popup-nav-btn:after {
  font-size: 18px !important;
  font-weight: bold;
}
.popup-nav-btn:hover {
  background: rgba(15, 23, 42, 0.95);
  border-color: #ffffff;
  transform: scale(1.08);
}

.popup-pagination {
  bottom: -24px !important;
}
</style>
